import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
export const FAQItem = ({
  question,
  answer
}: FAQItemProps) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-22">
      <button className="w-full flex justify-between items-center p-4 text-left bg-gray-50 hover:bg-gray-100 transition-colors" onClick={() => setIsOpen(!isOpen)} data-id="element-23">
        <span className="font-medium text-gray-900" data-id="element-24">{question}</span>
        {isOpen ? <ChevronUpIcon className="w-5 h-5 text-gray-500" data-id="element-25" /> : <ChevronDownIcon className="w-5 h-5 text-gray-500" data-id="element-26" />}
      </button>
      {isOpen && <div className="p-4 bg-white" data-id="element-27">
          <p className="text-gray-700" data-id="element-28">{answer}</p>
        </div>}
    </div>;
};